import React from 'react';
import {
    getImage, 
    GatsbyImage,
} from "gatsby-plugin-image";

import {
    SHeroGraphic,
    SGraphicBox,
} from './styles';

const HeroGraphic = ({
    imageData
}) => {
    const image = getImage(imageData.file)

    return (
        <SHeroGraphic>
            <SGraphicBox>
                <GatsbyImage
                    image={ image }
                    alt="hero image"
                />
            </SGraphicBox>
        </SHeroGraphic>
    );
};

export default HeroGraphic;
